// @ts-expect-error No types given for file

import { OBSIDIAN } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { connect } from 'react-redux';
import styled from 'styled-components';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { selectSearchStatus } from '../../selectors/searchState';

// Must explicitly set error color because the result's dropdown will use a
// disabled state with styling when displaying the error which effects the
// default color of the UIErrorMessage component.
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorMessage = styled(UIErrorMessage).withConfig({
  displayName: "SearchError__ErrorMessage",
  componentId: "sc-4npu1i-0"
})(["color:", ";"], OBSIDIAN);
function SearchError({
  loadingStatus
}) {
  const details = loadingStatus.get('errorDetails');
  if (details && details.status === 404) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      type: "notFound",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.notFound.searchResults"
      })
    });
  }
  return /*#__PURE__*/_jsx(ErrorMessage, {
    type: "badRequest"
  });
}
const mapStateToProps = state => ({
  loadingStatus: selectSearchStatus(state)
});
export default connect(mapStateToProps)(SearchError);